import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import * as Aos from 'aos';
import { Sl04Element } from 'src/assets/models/Sl04Element.model';
import { environment } from 'src/environments/environment';
import { Sl04DataService } from 'src/app/sl04-data.service';

@Component({
  selector: 'sl04',
  templateUrl: './sl04.component.html',
  styleUrls: ['./sl04.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state('inactive', style({ height: '0', overflow: 'hidden' })),
      state('active', style({ height: '*', overflow: 'visible' })),
    ])
  ]
})
export class SL04Component implements OnInit {
  company = environment.company;

  constructor(private sl04DataService: Sl04DataService) {}
  
  @Input() package: any;
  @Input() showContentFromSl04: boolean = false;
  protected slide002Items: Sl04Element[];

  ngOnInit(): void {
    Aos.init({
      once: true,
      delay: 0
    })

    if (this.package) {
      this.sl04DataService.setPackage(this.package);
    }
    const savedPackage = this.sl04DataService.getPackage();
    if (savedPackage) {
      this.package = savedPackage;
    }
    this.getSl04Items();
  }

  private getSl04Items(): void {
    this.slide002Items = this.package.elements;
    this.slide002Items[0].active = true;
  }

  protected toggleSl04Element(item: Sl04Element, index: number): void {
    this.slide002Items = this.slide002Items.map((element, indexToAnalyze) => {
      if (indexToAnalyze === index) {
        element.active = true;
      } else {
        element.active = false;
      }
      return element;
    });
  }

}
